import { render, staticRenderFns } from "./ProductCategoryCard.vue?vue&type=template&id=61564ffc&scoped=true"
import script from "./ProductCategoryCard.vue?vue&type=script&lang=js"
export * from "./ProductCategoryCard.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoryCard.vue?vue&type=style&index=0&id=61564ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61564ffc",
  null
  
)

export default component.exports